import { createContext } from 'react'

export interface PermissionsContextProps {
  canViewCPReports: boolean
  canEditCPReports: boolean
  canSubmitFinalCPReport: boolean
  canDeleteCPReports: boolean
  canExportCPReports: boolean
  canViewBp: boolean
  canUpdateBp: boolean
  canViewReplenishment: boolean
  canEditReplenishment: boolean
  canViewV1Projects: boolean
  canViewProjects: boolean
  canViewMetainfoProjects: boolean
  canViewSectorsSubsectors: boolean
  canUpdateProjects: boolean
  canUpdateV3Projects: boolean
  canSubmitProjects: boolean
  canRecommendProjects: boolean
  canApproveProjects: boolean
  canAssociateProjects: boolean
  canDisassociateProjects: boolean
  canDisassociateComponents: boolean
  canEditProjects: boolean
  canEditApprovedProjects: boolean
  canViewProductionProjects: boolean
  canUpdatePostExcom: boolean
  canTransferProjects: boolean
  canViewMyaData: boolean
  canManageMyaData: boolean
  canViewFundingWindow: boolean
  canManageFundingWindow: boolean
  canViewEnterprises: boolean
  canEditEnterprise: boolean
  canSetProjectSettings: boolean
  isMlfsUser: boolean
  isSuperuser: boolean
  canViewOnlyOwnAgency: boolean
  canCommentCPCountry: boolean
  canCommentCPSecretariat: boolean
  isCPCountryUserType: boolean
  isBpAdmin: boolean
  canViewAPR: boolean
  canEditAPR: boolean
  canSubmitAPR: boolean
  canViewPCR: boolean
  canEditPCR: boolean
  canSubmitPCR: boolean
  canEditSubmittedPCR: boolean
  canRequestAdjustmentsPCR: boolean
  canApprovePCR: boolean
  canMarkPCRDue: boolean
}

const PermissionsContext = createContext<PermissionsContextProps>(
  null as unknown as PermissionsContextProps,
)

export default PermissionsContext
